import script from "./tablePrinter.vue?vue&type=script&setup=true&lang=js"
export * from "./tablePrinter.vue?vue&type=script&setup=true&lang=js"

import "./tablePrinter.vue?vue&type=style&index=0&id=eb667c54&scoped=true&lang=scss"
import "./tablePrinter.vue?vue&type=style&index=1&id=eb667c54&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb667c54"]])

export default __exports__